import { render, staticRenderFns } from "./ScreenPageb.vue?vue&type=template&id=3962232b&scoped=true"
import script from "./ScreenPageb.vue?vue&type=script&lang=js"
export * from "./ScreenPageb.vue?vue&type=script&lang=js"
import style0 from "./ScreenPageb.vue?vue&type=style&index=0&id=3962232b&prod&lang=less&scoped=true"
import style1 from "./ScreenPageb.vue?vue&type=style&index=1&id=3962232b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3962232b",
  null
  
)

export default component.exports